import * as tslib_1 from "tslib";
import { Component } from 'vue-property-decorator';
import JSPage from '@/classes/JSPage';
import MaterialCard from '@/components/Base/MaterialCard/MaterialCard.vue';
let DashboardPage = class DashboardPage extends JSPage {
};
DashboardPage = tslib_1.__decorate([
    Component({
        components: { MaterialCard }
    })
], DashboardPage);
export default DashboardPage;
